var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProdcompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    className: "icon icon-cmcompare not-added",
    viewBox: "0 0 512 512",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M412.31,291.46,478,357.15l-65.69,65.68-21-21L421.07,372h-44a87.86,87.86,0,0,1-62.53-25.9l-159.2-159.2a58.29,58.29,0,0,0-41.5-17.19H34V140h79.87a87.83,87.83,0,0,1,62.53,25.91L335.6,325.08a58.27,58.27,0,0,0,41.5,17.19h44l-29.79-29.78Zm-257,33.65a59.1,59.1,0,0,1-41.53,17.16H34V372h79.81a89,89,0,0,0,62.54-25.86l53.7-53.51-21-21.07ZM335.63,186.89a59.09,59.09,0,0,1,41.53-17.16h43.91l-29.79,29.78,21,21L478,154.86,412.31,89.17l-21,21L421.07,140H377.16a89.08,89.08,0,0,0-62.58,25.89l-53.52,53.7,21.07,21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdcompare);
export default __webpack_public_path__ + "static/media/prodcompare.2bbfd340c94177fd1223af04956c03dc.svg";
export { ForwardRef as ReactComponent };